module.exports = __webpack_public_path__ + "fonts/4ba131c92a72fb4d73439493e2d9819a.txt";